var exports = {
  "t": "x52a3aa3b--d14bdb--backdrop",
};

module.exports = exports;
